export default {
  title: 'Ustawienia',
  reservation_hours_helper: 'Te godziny określają, kiedy goście mogą dokonywać rezerwacji online.',
  reservation_hours_alert:
    'Twoje godziny rezerwacji różnią się od regularnych godzin otwarcia. Goście mogą rezerwować tylko w godzinach podanych tutaj.',
  activated: 'Rezerwacje aktywne',
  deactivated: 'Rezerwacje nieaktywne',
  buttons: {
    activate: 'Aktywuj',
    deactivate: 'Dezaktywuj',
  },
  error_messages: {
    no_google_place: {
      title: 'Restauracja nie jest połączona z żadną lokalizacją Google',
      description: 'Połącz restaurację z lokalizacją Google',
    },
    toggle_failed: 'Nie udało się zaktualizować rezerwacji. Spróbuj ponownie.',
  },
};
